import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "company-settings" }
const _hoisted_2 = { class: "row q-col-gutter-md q-mb-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_company_information = _resolveComponent("company-information")!
  const _component_company_address = _resolveComponent("company-address")!
  const _component_business_registration_details = _resolveComponent("business-registration-details")!
  const _component_printer_information = _resolveComponent("printer-information")!
  const _component_shipping_providers = _resolveComponent("shipping-providers")!
  const _component_pricing_services = _resolveComponent("pricing-services")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_company_information, {
        tenant: _ctx.tenant,
        "onUpdate:companyInformation": _cache[0] || (_cache[0] = ($event: any) => (void _ctx.saveTenant($event)))
      }, null, 8, ["tenant"]),
      _createVNode(_component_company_address, {
        tenant: _ctx.tenant,
        "onUpdate:companyAddress": _cache[1] || (_cache[1] = ($event: any) => (void _ctx.saveTenant($event)))
      }, null, 8, ["tenant"])
    ]),
    _createVNode(_component_business_registration_details, {
      class: "q-mb-md",
      tenant: _ctx.tenant,
      "onUpdate:businessRegistrationDetails": _cache[2] || (_cache[2] = ($event: any) => (void _ctx.saveTenant($event)))
    }, null, 8, ["tenant"]),
    _createVNode(_component_printer_information, {
      class: "q-mb-md",
      printers: _ctx.printers?.configurations?.printer?.items,
      collection: _ctx.printers?.configurations?.printer?.collection.items,
      channels: _ctx.channels,
      onAddPrinter: _cache[3] || (_cache[3] = ($event: any) => (void _ctx.handleAddPrinter($event))),
      onUpdatePrinter: _cache[4] || (_cache[4] = ($event: any) => (void _ctx.handleUpdatePrinter(...$event))),
      onRemovePrinter: _cache[5] || (_cache[5] = ($event: any) => (void _ctx.handleRemovePrinter($event)))
    }, null, 8, ["printers", "collection", "channels"]),
    _createVNode(_component_shipping_providers, {
      class: "q-mb-xl",
      tenant: _ctx.tenant
    }, null, 8, ["tenant"]),
    _createVNode(_component_pricing_services, { class: "q-mb-xl" })
  ]))
}